import AdminBar from './AdminBar'

export default AdminBar
